import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
const StyledButton = styled(Button)(() => ({
    minHeight: '34px',
    // fontSize: theme.typography.caption.fontSize,
    lineHeight: 2,
    // fontWeight: theme.typography.fontWeightBold,
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    flexGrow: 1,
    margin: 1,
    padding: 0,
    // '&:hover': {
    //   border: `2px solid ${theme.palette.primary.main}`,
    //   borderRadius: '22px',
    // },
    // '&:focus-visible': {
    //   border: 'none',
    // },
}));
const CustomButton = ({ variant, areaID, startIcon, label, disabled, customStyle, onClick, className, }) => (_jsx(StyledButton, { disabled: disabled, "aria-describedby": areaID, onClick: onClick, variant: variant, startIcon: startIcon, className: className || 'site-button', disableRipple: true, sx: {
        px: 2,
        ...customStyle,
    }, children: label }));
CustomButton.defaultProps = {
    variant: 'outlined',
    areaID: null,
    startIcon: null,
    disabled: false,
    customStyle: {},
    className: 'site-button',
};
export default CustomButton;
//# sourceMappingURL=CustomButton.js.map